import { IAction } from '@entities/AdminConversationCategory/model/types';
import { IModalForm } from '@features/AdminConversationCategoryUpsertModal/model/types';

export const getUpsertModalFormData = (
    categoryId: number,
    form: IModalForm,
    type: 'broadcast' | 'survey',
    isEdit: boolean,
    actions: IAction[] = []
) => {
    const formData = new FormData();

    formData.append('category_id', `${categoryId}`);
    formData.append('type', type);
    formData.append('title', form.title.trim());
    if (form.description) formData.append('description', form.description.trim());
    if (form.link) formData.append('survey_url', form.link.trim());
    if (form.comment) formData.append('private_description', form.comment.trim());
    // @ts-ignore
    if (form.attachment.length && form.attachment[0]?.file) {
        // @ts-ignore
        formData.append('image', form.attachment[0]?.file);
    }

    if (isEdit && type === 'broadcast') {
        const buttons = actions.filter((button) => button.type !== 'close');

        if (form.primaryText) {
            formData.append('actions_id[]', buttons[0]?.id ? `${buttons[0].id}` : '');
            formData.append('actions_text[]', form.primaryText.trim());
            formData.append('actions_url[]', form.primaryLink.trim());
        } else {
            formData.append('actions_id[]', buttons[0]?.id ? `${buttons[0].id}` : '');
            formData.append('actions_text[]', '');
            formData.append('actions_url[]', '');
        }
        if (form.secondaryText) {
            formData.append('actions_id[]', buttons[1]?.id ? `${buttons[1].id}` : '');
            formData.append('actions_text[]', form.secondaryText.trim());
            formData.append('actions_url[]', form.secondaryLink.trim());
        } else {
            formData.append('actions_id[]', buttons[1]?.id ? `${buttons[1].id}` : '');
            formData.append('actions_text[]', '');
            formData.append('actions_url[]', '');
        }
    } else {
        if (form.primaryText) {
            formData.append('actions_text[]', form.primaryText.trim());
            formData.append('actions_url[]', form.primaryLink.trim());
        }
        if (form.secondaryText) {
            formData.append('actions_text[]', form.secondaryText.trim());
            formData.append('actions_url[]', form.secondaryLink.trim());
        }
    }

    return formData;
};
